import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../ReduxToolkit/Hooks';
import { Container, Card, CardBody, Col, Row, Input, Button, Table } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import moment from 'moment'

import { deleteReportAction, getReportListAPI } from '../../../Api/report';
import GridPage from './GridPage';
import { H5 } from '../../../AbstractElements';
import { useNavigate } from 'react-router-dom';
import { Search } from 'react-feather';
import GeneratingLoader from '../../../CommonElements/GeneratingLoader/GeneratingLoader';
import axios from 'axios';

const AllReportsContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loggedIn } = useAppSelector(state => state.user);
  const [tempQuery, setTempQuery] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [perPage, setPerPage] = useState<number>(10);
  const [displayReports, setDisplayReports] = useState<any[]>([]);

  const [reportItems, setReportItems] = useState<any>(null);
  const [reportOffset, setReportOffset] = useState(0);
  const [reportPageCount, setReportPageCount] = useState(0);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * perPage) % displayReports.length;
    setReportOffset(newOffset)
  }

  useEffect(() => {
    setLoading(true)
    const fetchReports = async () => {
      const { reports } = await getReportListAPI();
      setLoading(false)
      setDisplayReports(reports)
    };
    fetchReports()
  }, [])

  const deleteReport = async (reportId: any) => {
    setLoading(true)

    await deleteReportAction(reportId)
    const { reports } = await getReportListAPI();
    setLoading(false)
    setDisplayReports(reports)
  }

  useEffect(() => {
    const endReportOffset = reportOffset + perPage;
    setReportItems(
      displayReports.slice(reportOffset, endReportOffset)
    )

    setReportPageCount(Math.ceil(displayReports.length / perPage))
  }, [reportOffset, displayReports, perPage])


  const handleSearch = async () => {
    try {
      setLoading(true)
      const response: any = await axios.get(`/report/list?query=${tempQuery}`);
      setDisplayReports(response.data.payload.reports)
      setLoading(false)
    } catch (err: any) {
      console.log(err)
      setLoading(false)
    }
  }

  const handleChangePerPage = (e: any) => {
    setPerPage(parseInt(e.target.value))
  }
  return (
    <Container fluid>
      {loading && <GeneratingLoader label="Loading..." />}

      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <Row>
                <h5 className="mb-1" style={{ fontSize: 18 }}> {"Browse"}</h5>
                <Col sm={8} className="d-flex mb-3" style={{ gap: 8 }}>
                  <Input
                    className="border "
                    placeholder="Search by name"
                    onChange={(e) => {
                      setTempQuery(e.target.value)
                    }}
                    value={tempQuery} />
                  <Button
                    className="px-3 pt-2 pb-1"
                    onClick={() => handleSearch()}
                  >
                    <Search width={20} height={18} />
                  </Button>
                </Col>
                <Col sm={4} className='d-flex justify-content-end mb-3'>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardBody className="gallery my-gallery mb-0">
              <div>
                {
                  displayReports.length > 0
                    ? <div className="table-responsive theme-scrollbar">
                      <Table className="table display dataTable no-footer" id="selling-product">
                        <thead>
                          <tr>
                            <th style={{ textAlign: 'center' }}>{"No"}</th>
                            <th style={{ textAlign: 'center' }}>{"Patient Name"}</th>
                            <th style={{ textAlign: 'center' }}>{"Patient Type"}</th>
                            <th style={{ textAlign: 'center' }}>{"Template"}</th>
                            <th style={{ textAlign: 'center' }}>{"Created At"}</th>
                            <th style={{ textAlign: 'center' }} className="text-center">{"Actions"}</th>
                          </tr>
                        </thead>
                        {
                          reportItems.map((report: any, index: any) => {
                            return (
                              <tr key={index}>
                                <td style={{ textAlign: 'center', borderBottom: '1px solid rgb(106 113 133 / 30%)', padding: 0 }}>{index + 1}</td>
                                <td style={{ textAlign: 'center', borderBottom: '1px solid rgb(106 113 133 / 30%)', padding: 0 }}>{report.patient}</td>
                                <td style={{ textTransform: 'capitalize', textAlign: 'center', borderBottom: '1px solid rgb(106 113 133 / 30%)', padding: 0 }}>{report.patientType}</td>
                                <td style={{ textAlign: 'center', borderBottom: '1px solid rgb(106 113 133 / 30%)', padding: 0 }}>{report.template.toUpperCase()}</td>
                                <td style={{ textAlign: 'center', borderBottom: '1px solid rgb(106 113 133 / 30%)', padding: 0 }}>{moment(report.created_at).format("DD-MM-YYYY HH:mm")}</td>
                                <td style={{ borderBottom: '1px solid rgb(106 113 133 / 30%)', padding: 0 }}>
                                  <div className="d-flex justify-content-center align-items-center" style={{ gap: '8px' }}>
                                    <Button
                                      color={`secondary`}
                                      className="d-flex align-items-center px-2 py-1"
                                      style={{ gap: '4px' }}
                                      onClick={() => {
                                        navigate(`/patient/report_generate?patient_id=${report.patientId}&from=${report.id}`)
                                      }}>{"Edit"}</Button>
                                    <Button
                                      color={`primary`}
                                      className="d-flex align-items-center px-2 py-1"
                                      style={{ gap: '4px' }}
                                      onClick={() => {
                                        navigate(`/patient/report_generate/${report.id}/preview`)
                                      }}>{"Preview"}</Button>
                                    <Button
                                      color={`danger`}
                                      className="d-flex align-items-center px-2 py-1"
                                      style={{ gap: '4px' }}
                                      onClick={() => deleteReport(report.id)}>{"Delete"}</Button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        }
                      </Table>
                    </div>
                    : <div>There aren't any reports yet</div>
                }
              </div>
              <div className=" d-flex justify-content-end align-items-center pagination-container mt-3" style={{ gap: 16 }}>

                <div className="d-flex align-items-center items-per-page" style={{ gap: 8 }}>
                  <H5>Per Page : </H5>
                  <Input
                    type="number"
                    value={perPage}
                    onChange={(e: any) => handleChangePerPage(e)}
                    style={{ width: 50, textAlign: 'center' }}
                  />
                </div>
                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                  <div>
                    <ReactPaginate
                      nextLabel=">"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={1}
                      pageCount={reportPageCount}
                      previousLabel="<"
                      breakLabel="..."
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item page-item-previous"
                      previousLinkClassName="page-link"
                      nextClassName="page-item page-item-next"
                      nextLinkClassName="page-link"
                      breakClassName="page-item page-item-break"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </div>
              </div>
              <GridPage />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AllReportsContainer;
